import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import Multiselect from "@cloudscape-design/components/multiselect";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Toggle from "@cloudscape-design/components/toggle";
import Spinner from "@cloudscape-design/components/spinner";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { gameStore } from "../stores/games";
import { fortuneWheelModalStore } from "../stores/fortuneWheelModal";
import Alert from "@cloudscape-design/components/alert";
import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Grid from "@cloudscape-design/components/grid";
import Header from "@cloudscape-design/components/header";
import { getRecoil, setRecoil } from "recoil-nexus";
import { playerPageStore } from "../stores/playerPage";

/* ------- */

class FortuneWheelModal extends React.Component {

	constructor(props) {
		super(props);
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			setTimeout(() => {
				this.props.Interface.loadInfoFortuneWheel(this.props.fortuneWheelModal.wheelId);
			}, 0);
		}
	};

	handleInputDebounceChange = (input, type) => {
		this.props.setFortuneWheelModal({
			...this.props.fortuneWheelModal,
			currentSearch: input.detail.value,
			pagination: {
				...this.props.fortuneWheelModal.pagination,
				current: 1,
			}
		});

		if (input.detail.value.length === 0) {
			setTimeout(() => {
				this.props.Interface.loadInfoFortuneWheel(this.props.fortuneWheelModal.wheelId);
			}, 250);
		}
	};

	render() {
		return (
			<>
				<Modal
					size="max"
					visible={this.props.fortuneWheelModal.show}
					onDismiss={() => {
						this.props.setFortuneWheelModal({ ...this.props.fortuneWheelModal,  show: false });
					}}
					header={<Box
						children={
							<Header
								children="Fortune wheel"
								counter={
									<>
										({this.props.fortuneWheelModal.pagination.count})
									</>
								}
							/>
						}
					/>}
					children={
						<>
							{this.props.fortuneWheelModal.loaded && this.props.fortuneWheelModal.error.text.length ? (
								<Box
									margin={{ bottom: "m" }}
									children={
										<Alert
											type="error"
											header="Error loading data:"
											children={
												<>
													<Box variant="p" children={this.props.fortuneWheelModal.error.text} />
													<hr />
													<Box
														variant="p"
														children={
															<>
																request error code: {this.props.fortuneWheelModal.error.code} | request timestamp: {this.props.fortuneWheelModal.error.timestamp}
															</>
														}
													/>
												</>
											}
										/>
									}
								/>
							) : (
								<></>
							)}
							<Table
								stickyHeader="true"
								trackBy="id"
								loading={!this.props.fortuneWheelModal.loaded}
								sortingColumn={{ sortingField: this.props.fortuneWheelModal.sorting.sortingColumn.column }}
								sortingDescending={this.props.fortuneWheelModal.sorting.isDescending}
								onSortingChange={(sorting) => {
									this.props.setFortuneWheelModal({ ...this.props.fortuneWheelModal, sorting: {
											...this.props.fortuneWheelModal.sorting,
											sortingColumn: {
												order: !sorting.detail.isDescending ? "ASC" : "DESC",
												column: sorting.detail.sortingColumn.sortingField
											},
											isDescending: sorting.detail.isDescending,
										} });
									setTimeout(() => {
										this.props.Interface.loadInfoFortuneWheel(this.props.fortuneWheelModal.wheelId);
									}, 250);
								}}
								columnDefinitions={[
									{
										id: "uid",
										header: "UID",
										sortingField: "uid",
										cell: (item) => (
											<Button
												iconName={"status-in-progress"}
												className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", item.status !== "none" ? this.props.styles["green"] : this.props.styles["blue"]].join(" ")}
												variant="normal"
												onClick={() => {
													this.props.setPlayerPage({...this.props.playerPage, show: false});
													setTimeout(() => {
														this.props.Interface.loadInfo(item.uid);
													}, 250);
												}}
												children={item.uid}
											/>
										),
									},
									{
										id: "amount",
										header: "Amount",
										sortingField: "amount",
										cell: (item) => 	<Box variant="span" color={item.amount >= 0 ? (item.amount > 0 ? "text-status-success" : "text-body-secondary") : "text-status-error"}>
											{new Intl.NumberFormat("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.amount / 100)} RUB.
										</Box>,
									},
									{ id: "Ip", header: "ip",  cell: (item) => item.ip},
									{ id: "status", header: "Status", sortingField: "status", cell: (item) => <>
											<Box variant="span" color={item.status !== "none" ? "text-status-success" : ""}>
												{item.status}
											</Box>
										</> },
									{ id: "date", header: "Date", sortingField: "date", cell: (item) => <>{new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString()}</> },
								]}
								items={this.props.fortuneWheelModal.data}
								pagination={
									<Pagination
										disabled={!this.props.fortuneWheelModal.loaded}
										currentPageIndex={this.props.fortuneWheelModal.pagination.current}
										pagesCount={this.props.fortuneWheelModal.pagination.total}
										onChange={(page) => {
											this.props.setFortuneWheelModal({ ...this.props.fortuneWheelModal, pagination: { ...this.props.fortuneWheelModal.pagination, current: page.detail.currentPageIndex } });
											setTimeout(() => {
												this.props.Interface.loadInfoFortuneWheel(this.props.fortuneWheelModal.wheelId);
											}, 250)
										}}
									/>
								}
								preferences={
									<Preferences
										cancelLabel="Cancel"
										confirmLabel="Confirm"
										pageSizePreference={{ title: "Logs per page", options: this.props.config.fortuneWheel.preferences.perPage }}
										preferences={{ pageSize: this.props.config.fortuneWheelModal.perPage }}
										title="Preferences"
										onConfirm={(preferences) => {
											localStorage.setItem("fortuneWheelModal.perPage", preferences.detail.pageSize);
											this.props.setConfig({ ...this.props.config, fortuneWheelModal: { ...this.props.config.fortuneWheelModal, perPage: preferences.detail.pageSize } });

											setTimeout(() => {
												this.props.Interface.loadInfoFortuneWheel(this.props.fortuneWheelModal.wheelId);
											}, 250);
										}}
									/>
								}
								filter={
									<Box
										margin={{ bottom: "m" }}
										children={
											<Grid
												gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
												children={
													<>
														<Input
															disableBrowserAutocorrect={true}
															placeholder="Ip, amount"
															inputMode="search"
															type="search"
															onKeyDown={this.handleKeyPress}
															value={this.props.fortuneWheelModal.currentSearch}
															onChange={(input) => {
																this.handleInputDebounceChange(input);
															}}
														/>
													</>
												}
											/>
										}
									/>
								}
								empty="No fortuneWheel found with requested filter"
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const fortuneWheelModal = useRecoilValue(fortuneWheelModalStore);
		const setFortuneWheelModal = useSetRecoilState(fortuneWheelModalStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const playerPage = useRecoilValue(playerPageStore);
		const setPlayerPage = useSetRecoilState(playerPageStore);
		return <Component {...props} playerPage={playerPage} setPlayerPage={setPlayerPage} setConfig={setConfig} fortuneWheelModal={fortuneWheelModal} setFortuneWheelModal={setFortuneWheelModal} config={config} />;
	};
}

export default withRecoil(FortuneWheelModal);
